<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      show-save-button
      title="添加运费明细"
      :in-dialog="inDialog"
      id-key="SupportId"
      :data="data"
      :form-rules="rules"
      @create-opened="onCreateOpened"
      :save-func="() => {}"
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row :gutter="10">
          <el-col :span="12">
            <districts
              ref="districts"
              :Lvs="[1, 2]"
              height="400px"
              @select="onSelect"
            />
          </el-col>
          <el-col :span="12">
            <div class="citys-head">选中的城市</div>
            <div class="citys-box m-scroll" style="height: 400px">
              <div class="item" v-for="(i, key) in Districts" :key="key">
                <span>{{ i.Name }}</span>
                <span
                  @click="remove(i.Id, key)"
                  class="el-icon-error close-btn"
                ></span>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 20px" v-if="Condition == '2'">
          <el-col :span="12">
            <el-form-item label="首件数量" prop="FirstQuantity">
              <el-input
                v-model="data.FirstQuantity"
                @blur="onBlur(data, 'FirstQuantity')"
                @focus="onFocus(data, 'FirstQuantity')"
                placeholder="请输入首件数量"
              ></el-input>
            </el-form-item>
            <el-form-item label="首件运费" prop="FirstFreight">
              <el-input
                v-model="data.FirstFreight"
                @blur="onBlur(data, 'FirstFreight')"
                @focus="onFocus(data, 'FirstFreight')"
                placeholder="请输入首件运费"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="继件数量" prop="AfterQuantity">
              <el-input
                v-model="data.AfterQuantity"
                @blur="onBlur(data, 'AfterQuantity')"
                @focus="onFocus(data, 'AfterQuantity')"
                placeholder="请输入继件数量"
              ></el-input>
            </el-form-item>
            <el-form-item label="继件运费" prop="AfterFreight">
              <el-input
                v-model="data.AfterFreight"
                @blur="onBlur(data, 'AfterFreight')"
                @focus="onFocus(data, 'AfterFreight')"
                placeholder="请输入继件运费"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 20px" v-if="Condition == '1'">
          <el-col :span="12">
            <el-form-item label="首件重量" prop="FirstWeight">
              <el-input
                v-model="data.FirstWeight"
                @blur="onBlur(data, 'FirstWeight')"
                @focus="onFocus(data, 'FirstWeight')"
                placeholder="请输入首件重量"
              >
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
            <el-form-item label="首件运费" prop="FirstFreight">
              <el-input
                v-model="data.FirstFreight"
                @blur="onBlur(data, 'FirstFreight')"
                @focus="onFocus(data, 'FirstFreight')"
                placeholder="请输入首件运费"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="继件重量" prop="AfterWeight">
              <el-input
                v-model="data.AfterWeight"
                @blur="onBlur(data, 'AfterWeight')"
                @focus="onFocus(data, 'AfterWeight')"
                placeholder="请输入继件重量"
              >
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
            <el-form-item label="继件运费" prop="AfterFreight">
              <el-input
                v-model="data.AfterFreight"
                @blur="onBlur(data, 'AfterFreight')"
                @focus="onFocus(data, 'AfterFreight')"
                placeholder="请输入继件运费"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="金额范围" class="is-required">
              <el-row>
                <el-col :span="11">
                  <el-form-item style="margin-bottom: 0;" prop="FirstAmount">
                    <el-input size="mini" @blur="onBlur(data,'FirstAmount')" @focus="onFocus(data,'FirstAmount')"  v-model="data.FirstAmount" placeholder="输入金额"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2" style="line-height:28px;font-size:18px;text-align:center;">~</el-col>
                <el-col :span="11">
                  <el-form-item style="margin-bottom: 0;" prop="AfterAmount">
                    <el-input size="mini" @blur="onBlur(data,'AfterAmount')" @focus="onFocus(data,'AfterAmount')" v-model="data.AfterAmount" placeholder="输入金额"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运费" prop="AmountFreight">
              <el-input v-model="data.AmountFreight" placeholder="请输入运费"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
      </template>
      <!--<template slot="form">
          <el-row :gutter="10">
            <el-col :span="12">
              <districts ref="districts" :Lvs="[1,2]" height="400px" @select="onSelect" />
            </el-col>
            <el-col :span="12">
              <div class="citys-head">选中的城市</div>
              <div class="citys-box m-scroll" style="height: 400px;">
                <div class="item" v-for="(i,key) in Districts" :key="key">
                  <span>{{i.Name}}</span>
                  <span @click="remove(i.Id,key)" class="el-icon-error close-btn"></span>
                </div>
              </div>
            </el-col>
          </el-row> 
           
      </template>-->
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import districts from "@/components/sale/freight/cityTree";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    districts,
  },
  props: {
    Condition: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      data: {
        SupportId: 0,
        FreightId: null,
        ProvinceId: null, //省
        ProvinceName: "",
        CityId: null, //市
        CityName: "",
        DistrictId: null, //区
        DistrictName: "",
        FreightType: 0, //0:异地 1:本地
        FirstQuantity: 0, //异地：首件；本地：范围
        FirstFreight: 0, //异地：首件运费；本地：运费
        AfterQuantity: 0, //异地：继件；本地：范围
        AfterFreight: 0, //异地：继件运费
        FirstWeight: 0, //金额范围
        AfterWeight: 0, //金额范围
        AmountFreight: 0, //金额范围内运费
      },
      Districts: [], //选中的城市
      api: require("@/api/sale/freightSupport").default,
      rules: {
        FirstQuantity: [
          { required: true, message: "数量不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        FirstFreight: [
          { required: true, message: "运费不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        AfterQuantity: [
          { required: true, message: "数量不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        AfterFreight: [
          { required: true, message: "运费不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        FirstWeight: [
          { required: true, message: "重量不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        AfterWeight: [
          { required: true, message: "重量不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
        AmountFreight: [
          { required: true, message: "运费不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    onCreateOpened(data) {
      var filterIds = []; //不支持配送区域的省Id
      data.UnSupport.forEach((x) => {
        if (x.CityId != 0) filterIds.push(x.CityId);
        else filterIds.push(x.ProvinceId);
      });
      filterIds = filterIds.filter((x) => x != 0);
      data.filterIds = filterIds;
      this.$refs.districts.init(data);
    },
    onSelect(data) {
      var item = {
        Id: data.DistrictId,
        ProvinceId: data.ProvinceId, //省
        ProvinceName: data.ProvinceName,
        CityId: data.DistrictId, //市
        // CityName: data.CityName,
        // DistrictId: 0, //区
        // AreaName: "",
        // Pid: data.Pid,
        Name: data.NameChain,
      };
      // if (data.Lv == 1) item.Name = data.Name;
      // if (data.Lv == 2) item.Name = data.ProvinceName + "/" + data.Name;
      if (item) this.Districts.push(item);
    },
    remove(id, index) {
      this.$refs.districts.remove(id);
      this.Districts.splice(index, 1);
    },
    onBeforeSave() {
      //
      if (this.Districts.length == 0) {
        this.$message.warning("请选择城市");
        return false;
      }
      var rows = this.Districts.map((x) => {
        return {
          // SupportId: this.data.SupportId,
          // FreightId: this.data.FreightId,
          // ProvinceId: x.ProvinceId, //省
          // ProvinceName: x.ProvinceName,
          // CityId: x.CityId, //市
          // CityName: x.CityName,
          // DistrictId: x.DistrictId, //区
          // AreaName: x.AreaName,
          // FreightType: 0, //0:异地 1:本地
          // FirstQuantity: this.data.FirstQuantity, //异地：首件；本地：范围
          // FirstFreight: this.data.FirstFreight, //异地：首件运费；本地：运费
          // AfterQuantity: this.data.AfterQuantity, //异地：继件；本地：范围
          // AfterFreight: this.data.AfterFreight, //异地：继件运费
          // FirstAmount:this.data.FirstAmount,//金额范围
          // AfterAmount:this.data.AfterAmount,//金额范围
          // AmountFreight:this.data.AmountFreight, //金额范围内运费
          T: 0,
          //---------------------------------------------
          AreaName: x.Name,
          RecordId: 0,
          ProvinceId: x.ProvinceId, //省
          ProvinceName: x.ProvinceName,
          CityId: x.CityId, //市
          CityName: x.CityName,
          FreightType: 0, //0:异地 1:本地
          DistrictId: x.Id,
          FirstQuantity: this.data.FirstQuantity, //异地：首件；本地：范围
          FirstFreight: this.data.FirstFreight, //异地：首件运费；本地：运费
          AfterQuantity: this.data.AfterQuantity, //异地：继件；本地：范围
          AfterFreight: this.data.AfterFreight, //异地：继件运费
          FirstWeight: this.data.FirstWeight, //重量范围
          AfterWeight: this.data.AfterWeight, //重量范围
          AmountFreight: this.data.AmountFreight, //金额范围内运费
        };
      });

      // this.$refs.dialog.isLoading = true;
      // this.api.saveList(rows).then((res) => {
      //   if (res.Code == 0) {
      //     this.$emit("detail-save", res.Data);
      //     this.close(true);
      //   } else {
      //     this.$message.error("保存失败");
      //   }
      //   this.$refs.dialog.isLoading = false;
      // });
      console.log(rows, "detail-save");
      this.$emit("detail-save", rows);
      this.close(true);
      return false;
    },
    onClosed() {
      this.Districts = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.citys-head {
  width: 100%;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  border: 1px solid #ebeef5;
  border-bottom: none;
}
.citys-box {
  overflow-y: auto;
  border: 1px solid #ebeef5;
  .item {
    line-height: 40px;
    font-size: 16px;
    width: 100%;
    display: inline-block;
    padding-left: 10px;
    cursor: default;
    .close-btn {
      float: right;
      line-height: 40px;
      margin-right: 13px;
      color: #7b7b7b;
    }
  }
  .item:hover {
    background-color: #eefff9;
  }
}
</style>